module.exports = __webpack_public_path__ + "img/player-pause-icon.819a9a64.svg";